module.exports = __webpack_public_path__ + "static/media/laptop.7126a6b9.jpg";